module.exports = __webpack_public_path__ + "static/media/placeholder5.057c6cb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder5.jpg
// module id = 627
// module chunks = 0